import React, { useContext, useEffect, useMemo, useState } from 'react'
import { SportsSeasonContext } from '../cnr/contexts/SportsSeasonContext'
import { Button, Icon, Label } from 'semantic-ui-react'
import Wrapper, { wrapperTypes } from 'global/wrappers/Wrapper'
import ItemMenuSquares, { _imsTypes } from 'global/wrappers/ItemMenuSquares'
import CalSchedule from 'global/components/calendar/CalSchedule'
import WrapperVertCols from 'global/wrappers/WrapperVertCols'
import { _msTypes } from '../elements/matches/MatchSquares'
import { gameScoringTypes } from '../cnr/reducers/SportsSeasonReducer'
import _ from 'lodash'
import TeamSchedule from '../elements/schedule/TeamSchedule'
import { matchCalcs } from '../helpers/match'
import { useCreateSeasonData } from '../useHelpers/useCreateSeasonData'
import { openExternal } from 'global/viewSettings/helpers/settingsLinks'
import { _sportCollections } from '../cnr/reducers/SportsSidebarReducer'
import { ParentContext } from 'global/cnr/contexts/ParentContext'
import { _allowSportsUpdates } from '../useHelpers/useSeasonals'

export const ModifySeasonMatches = () => {

  const parentContext = useContext(ParentContext);
  const { states, fns } = parentContext ?? {}
  const { paps_state } = states ?? {}
  const { pathViews } = paps_state ?? {}
  const { database_fns } = fns ?? {}

  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state } = sportsSeasonContext ?? {}
  const { currentSeason_info, teams_info, matches_info } = sportsSeason_state ?? {}
  const { teams } = teams_info ?? {}
  const { matches_combined } = matches_info ?? {}
  const { gameScoringType, currentSeason: selectedYear, sportsKey } = currentSeason_info ?? {}

  const [matches_season] = useState(_.cloneDeep(matches_combined))
  const [team_selected, setTeam_selected] = useState()
  const [team_opponent, setTeam_opponent] = useState()
  const [matches_team, setMatches_team] = useState([])
  const [matches_opp, setMatches_opp] = useState([])
  const [matches_team_new, setMatches_teamNew] = useState([])
  const [matches_team_removed, setMatches_teamRemoved] = useState([])
  const [updating, setUpdating] = useState()

  const { update_seasonalMatches } = useCreateSeasonData()

  const handleSelect_team = (team) => {
    setTeam_selected(team)
    setTeam_opponent()
    setMatches_opp([])
  }

  const handleSelect_opponent = (team) => setTeam_opponent(team)

  useEffect(() => {
    if (matches_season) {
      const _matches_team = _.filter(matches_season, (match) =>
        _.includes(match.teams, team_selected?._itemKey)
      );
      setMatches_team(_matches_team)
      setMatches_teamNew([])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [team_selected]);

  useEffect(() => {
    const _matches_opp = _.filter(matches_season, (match) =>
      _.includes(match.teams, team_opponent?._itemKey)
    );
    setMatches_opp(_matches_opp)
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [team_opponent]);

  const matches_teamsCombined = useMemo(() => {
    const cbn = _.concat(matches_team, matches_team_new);
    return _.sortBy(cbn, 'startDate')
  }, [matches_team, matches_team_new]);

  const matches_teamsUpdated = useMemo(() => {
    const cbn = _.filter(matches_team, { _updated: true });
    return _.sortBy(cbn, 'startDate')
  }, [matches_team]);

  const matches_teamsUpdates = useMemo(() => {
    const _matches = {}
    _.forEach(matches_team_new, m => {
      _matches[m._itemKey] = m
    })

    _.forEach(matches_teamsUpdated, m => {
      _matches[m._itemKey] = m
    })
    return _matches
  }, [matches_team_new, matches_teamsUpdated]);

  const matches_teamsOppCombined = useMemo(() => {
    const cbn = _.concat(matches_opp, matches_team_new);
    return _.sortBy(cbn, 'startDate')
  }, [matches_opp, matches_team_new]);

  const createMatch = (newMatch, startDate, startTime) => {

    newMatch._itemKey = database_fns.get_docKey()
    newMatch.startDate = startDate || '??????'
    newMatch.startTime = startTime
    newMatch.sections = 'Non'

    switch (gameScoringType) {
      case gameScoringTypes.match:
      case gameScoringTypes.matchPoints:
        newMatch.bestOf = true
        newMatch.setCount = 5
        break;
      default:
      // nothing
    }

    newMatch.teams = [newMatch.home._itemKey, newMatch.away._itemKey]

    if (newMatch.away.levels === newMatch.home.levels) {
      newMatch.levels = newMatch.home.levels
      newMatch._matchCollectionKey = newMatch.home.levels
    } else {
      newMatch.levels = 'Non'
    }

    newMatch.ls = `${newMatch.levels} - ${newMatch.sections}`

    matchCalcs.calcVballMatch(newMatch, gameScoringType)

    return newMatch
  }

  const handleUpdate_matches = () => {
    setUpdating(true)
    const cb = () => setUpdating(false)
    const opts = { selectedYear, sportsKey }
    const _matches = {}

    _.forEach(matches_team_new, m => {
      _matches[m._itemKey] = m
    })

    _.forEach(matches_teamsUpdated, m => {
      _matches[m._itemKey] = m
    })

    update_seasonalMatches({
      matchesToUpdate: _matches,
      opts,
      callback: cb
    })
  }

  const handleOnDrop = (item) => {
    const { itemType, _itemKey, date, isAway } = item ?? {}
    const _teamMatches = _.cloneDeep(matches_team);
    const _matches_team_new = _.cloneDeep(matches_team_new);
    console.log('itemType', itemType)
    switch (itemType) {
      case 'team':
        const _team = teams?.[_itemKey]
        const _opp = {
          name: _team.name,
          _itemKey: _team._itemKey,
          id: _team._itemKey,
          sections: _team.sections,
          levels: _team.levels
        }
        handleAdd_match(_opp, date, isAway)
        break;
      case 'match':
        const _match = _.find(_teamMatches, { _itemKey });
        if (_match) {
          _match.startDate = date;
          _match._updated = true
        }
        setMatches_team(_teamMatches);
        break;
      case '_match':
        const _matchh = _.find(_teamMatches, { _itemKey });
        if (_matchh) {
          _matchh.startDate = date;
          _matchh._updated = true
          setMatches_team(_teamMatches);
        }
        const _matchh_n = _.find(_matches_team_new, { _itemKey });
        if (_matchh_n) {
          _matchh_n.startDate = date;
          _matchh_n._updated = true
          setMatches_teamNew(_matches_team_new);
        }
        break;
      case 'remove':
        const _match_d = _.find(_teamMatches, { _itemKey });
        if (_match_d) {
          _match_d._removed = true
        }
        // _.remove(_teamMatches, { _itemKey })
        _.remove(_matches_team_new, { _itemKey })
        setMatches_team(_teamMatches);
        setMatches_teamNew(_matches_team_new);
        break;
    }
  }

  const handleAdd_match = (opp, sd, isAway) => {
    const _sel = {
      name: team_selected.name,
      _itemKey: team_selected._itemKey,
      id: team_selected._itemKey,
      sections: team_selected.sections,
      levels: team_selected.levels
    }
    const match = {
      away: isAway ? _sel : opp,
      home: isAway ? opp : _sel,
      startDate: sd,
      _matchCollectionKey: 'Non',
      _updated: true

    }
    const nm = createMatch(match, sd, '7:00 PM')
    const _teamMatches = _.cloneDeep(matches_team_new)
    _teamMatches.push(nm)
    setMatches_teamNew(_teamMatches)
  }

  const cnt_teams_selected = (item) => cnt_teams(item)
  const cnt_teams_opp = (item) => cnt_teams(item, true)

  const cnt_teams = (item, includeDrag) => {
    const { sections, levels, _itemKey } = item
    const _matches_opp = _.filter(matches_teamsCombined, (match) =>
      _.includes(match.teams, _itemKey)
    );
    return <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '.25em' }}>
      {includeDrag && !_.isEmpty(_matches_opp) && <Label color='green' size='mini'>{_.size(_matches_opp)}</Label>}
      <Label size='mini'>{levels}</Label>
      <Label size='mini'>{_.startCase(sections)}</Label>
      {includeDrag && <div
        draggable="true"
        onDragStart={(e) => {
          const dt = {
            _itemKey: item._itemKey,
            itemType: 'team',
            name: item?.name,
          }
          e.dataTransfer.setData('application/json', JSON.stringify(dt));
          handleSelect_opponent(item)
        }}
        style={{ cursor: 'grab' }}
      >
        <Icon color='blue' name='expand arrows alternate' />
      </div>}
    </div>
  }

  const content_team_selected = (oc, seletedItem) => {
    let _sportSeasonTeams = _.sortBy(teams, 'name')
    return <Wrapper
      header={'Teams'}
      content={<ItemMenuSquares
        menuItems={_sportSeasonTeams}
        iconItem={'users'}
        imsType={_imsTypes.inline}
        onClick={oc}
        activeItem={seletedItem?.name}
        fn_altContent={cnt_teams_selected}

      />}
      wrapperType={wrapperTypes.padded}
    />
  }

  const getTeamMatches = (teams) => {
    _.forEach(teams, team => {
      const _matches_opp = _.filter(matches_teamsCombined, (match) =>
        _.includes(match.teams, team?._itemKey)
      );
      team._matchCount = _.size(_matches_opp)
    })
  }

  const content_teams = (oc, seletedItem) => {
    const updatedTeams = _.filter(teams, (team) => team?._itemKey !== team_selected?._itemKey);
    getTeamMatches(updatedTeams)
    let _sportSeasonTeams = _.orderBy(updatedTeams, ['_matchCount', 'name'], ['desc', 'asc'])
    return <Wrapper
      header={'Opponents'}
      content={team_selected ? <ItemMenuSquares
        menuItems={_sportSeasonTeams}
        iconItem={'users'}
        imsType={_imsTypes.inline}
        onClick={oc}
        activeItem={seletedItem?.name}
        fn_altContent={cnt_teams_opp}
      /> : <div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{'Select Team'}</div>}
      wrapperType={wrapperTypes.padded}
    />
  }

  const header_calendar = () => <div style={{ display: 'flex', justifyContent: 'space-between' }}>
    <div>{team_selected ? `${team_selected?.name} Calendar: ${_.size(matches_teamsCombined)} Match(es)` : 'Calendar'}</div>
    <div><Icon
      name='trash alternate outline'
      onDrop={(e) => {
        e.preventDefault();
        const dt = JSON.parse(e.dataTransfer.getData('application/json'));
        handleOnDrop({
          itemType: 'remove',
          _itemKey: dt?._itemKey,
        })
      }}
    /></div>
  </div>

  const content_calendar = () => {
    return <Wrapper
      header={team_selected ? header_calendar() : 'Calendar'}
      content={team_selected ? <CalSchedule
        matches={matches_teamsCombined}
        matches_opp={matches_teamsOppCombined}
        teamKey={team_selected?._itemKey}
        handle_onDrop={handleOnDrop}
      /> : <div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{'Select Team'}</div>}
      wrapperType={wrapperTypes.padded}
    />
  }

  const content_matches_selected = () => {
    return <Wrapper
      header={team_selected ? `${team_selected?.name}: ${_.size(matches_teamsCombined)} Match(es)` : 'Matches'}
      content={team_selected ? <TeamSchedule
        teamKey={team_selected?._itemKey}
        matches_team={matches_teamsCombined}
        allowDrag={false}
      /> : <div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{'Select Team'}</div>}
      wrapperType={wrapperTypes.padded}
      updating={updating}
    />
  }

  const externals = {
    seasonMatches: () => openExternal.firebaseDbDirect(pathViews, [_sportCollections._matches_seasonal, sportsKey]),
  }

  const content_season = () => <Wrapper
    content={
      <WrapperVertCols mvc={4}>
        {teams ? content_team_selected(handleSelect_team, team_selected) : <div>Away Team</div>}
        {teams ? content_teams(handleSelect_opponent, team_opponent) : <div>Home Team</div>}
        {content_calendar()}
        {content_matches_selected()}
      </WrapperVertCols>
    }
    footer={<div style={{ display: 'flex', justifyContent: 'space-between' }}>
      <div>
        <Button
          labelPosition='right'
          content={`Open Season Matches`}
          size='mini'
          color={'orange'}
          icon='external alternate'
          onClick={() => { externals.seasonMatches() }} />
      </div>
      <div>
        <Button
          labelPosition='right'
          content={`Update ${_.size(matches_teamsUpdates)} Match(es)`}
          size='mini'
          color={_.isEmpty(matches_teamsUpdates) ? 'grey' : _allowSportsUpdates.matches ? 'green' : 'teal'}
          icon='save'
          disabled={_.isEmpty(matches_teamsUpdates)}
          onClick={() => { handleUpdate_matches() }} />
      </div>
    </div>}
    wrapperType={wrapperTypes.paddedFooter}
  ></Wrapper>

  return (
    content_season()
  )
}
